import type { IconType } from 'react-icons';
import type { ReactNode } from 'react';

export interface EmptyStateProps {
    Icon?: IconType;
    title: string;
    description?: string;
    action?: ReactNode;
}

/** Guidance-first empty state — FR-27 asks for this on a zero-referral dashboard. */
export default function EmptyState({ Icon, title, description, action }: EmptyStateProps) {
    return (
        <div className="flex flex-col items-center justify-center rounded-xl border border-dashed border-[#DADADA] bg-[#fafafa] px-6 py-14 text-center">
            {Icon && (
                <span className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10 text-primary">
                    <Icon size={22} />
                </span>
            )}
            <p className="text-[16px] font-bold text-secondary">{title}</p>
            {description && <p className="mt-2 max-w-md text-[14px] leading-6 text-[#747474]">{description}</p>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}
